import { createRouter, createWebHistory } from "vue-router";
import { INTERVIEW_MODULE } from "@/constant/interview/interview_project.js";
import VueCookies from "vue-cookies";
import { httpPostRefreshToken } from "@/api/httpService";
import * as ws from "@/utils/websocket";
import { goLogin } from "@/utils/login";
import { getWebsocketMessage } from "@/utils/websocketMessage";
import {
  checkUserLoginStatus,
  synchronizeUserPermission,
} from "@/utils/utils.js";

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: 'Login' */ "@/views/Login.vue"),
  },
  {
    path: "/pricing",
    name: "Pricing",
    component: () =>
      import(/*webpackChunkName: "Index" */ "@/views/index/pricing.vue"),
    meta: {
      ifHidePadding: true,
    },
  },
  {
    path: "/",
    name: "Index",
    component: () =>
      import(/*webpackChunkName: "Index" */ "@/views/index/Index2.vue"),
    meta: {
      ifHidePadding: true,
    },
  },
  // {
  //   path: "/",
  //   redirect: "/index",
  //   component: () =>
  //     import(
  //       /*webpackChunkName: "Layout" */ "@/components/layout/IndexLayout.vue"
  //     ),
  //   children: [
  //     // {
  //     //   path: "/login",
  //     //   name: "login",
  //     //   component: () =>
  //     //     import(/*webpackChunkName: "Index" */ "@/views/login/index.vue"),
  //     // },
  //   ],
  // },
  {
    path: "/",
    component: () =>
      import(
        /* webpackChunkName: 'Layout' */ "@/components/layout/BaseLayout.vue"
      ),
    children: [
      {
        path: "home",
        name: "Home",
        component: () =>
          import(/* webpackChunkName: 'Home' */ "@/views/Home.vue"),
        meta: {
          ifHidePadding: true,
        },
      },
    ],
  },
  {
    path: "/:projectUid(\\d{16})",
    component: () =>
      import(
        /* webpackChunkName: 'Interview' */ "@/components/layout/InterviewLayout.vue"
      ),
    children: [
      {
        path: "interview",
        name: "InterviewList",
        component: () =>
          import(
            /* webpackChunkName: 'Interview' */ "@/views/interview/List.vue"
          ),
        meta: {
          ifHidePadding: true,
          module: INTERVIEW_MODULE.INTERVIEW,
        },
      },
      {
        path: "interview/:interviewUid",
        name: "InterviewDetail",
        component: () =>
          import(
            /* webpackChunkName: 'Interview' */ "@/views/interview/Detail.vue"
          ),
        meta: {
          ifHidePadding: true,
          ifHideFooter: true,
          module: INTERVIEW_MODULE.INTERVIEW,
        },
      },

      {
        path: "detail",
        name: "InterviewProjectDetail",
        component: () =>
          import(
            /* webpackChunkName: 'Interview' */ "@/views/interviewProject/Detail.vue"
          ),
        meta: {
          ifHidePadding: true,
          module: INTERVIEW_MODULE.DETAIL,
        },
      },
      // {
      //   path: "index",
      //   name: "InterviewList",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: 'Interview' */ "@/views/interview/List.vue"
      //     ),
      //   meta: {
      //     ifHidePadding: true,
      //   },
      // },
      {
        path: "outline",
        name: "InterviewOutline",
        component: () =>
          import(
            /* webpackChunkName: 'Interview' */ "@/views/outline/Index.vue"
          ),
        meta: {
          ifHidePadding: true,
          module: INTERVIEW_MODULE.OUTLINE,
        },
      },
      {
        path: "outline/template",
        name: "InterviewOutlineTemplateManage",
        component: () =>
          import(
            /* webpackChunkName: 'Interview' */ "@/views/outline/TemplateList.vue"
          ),
        meta: {
          ifHidePadding: true,
          module: INTERVIEW_MODULE.OUTLINE,
        },
      },
      {
        path: "outline/template/:templateUid",
        name: "InterviewOutlineTemplateDetail",
        component: () =>
          import(
            /* webpackChunkName: 'Interview' */ "@/views/outline/TemplateDetail.vue"
          ),
        meta: {
          ifHidePadding: true,
          module: INTERVIEW_MODULE.OUTLINE,
        },
      },
      {
        path: "outline/:outlineUid",
        name: "InterviewOutlineDetail",
        component: () =>
          import(
            /* webpackChunkName: 'Interview' */ "@/views/outline/Detail.vue"
          ),
        meta: {
          ifHidePadding: true,
          module: INTERVIEW_MODULE.OUTLINE,
        },
      },
      {
        path: "report",
        name: "InterviewReport",
        component: () =>
          import(
            /* webpackChunkName: 'Interview' */ "@/views/report/Index.vue"
          ),
        meta: {
          ifHidePadding: true,
          module: INTERVIEW_MODULE.REPORT,
        },
      },
      {
        path: "attachment",
        name: "InterviewAttachment",
        component: () =>
          import(
            /* webpackChunkName: 'Interview' */ "@/views/attachment/Index.vue"
          ),
        meta: {
          ifHidePadding: true,
          module: INTERVIEW_MODULE.ATTACHMENT,
        },
      },

      {
        path: "team",
        name: "InterviewTeam",
        component: () =>
          import(/* webpackChunkName: 'Team' */ "@/views/team/Index.vue"),
        meta: {
          ifHidePadding: true,
          module: INTERVIEW_MODULE.TEAM,
        },
      },
      {
        path: "sample",
        name: "InterviewSample",
        component: () =>
          import(
            /* webpackChunkName: 'Interview' */ "@/views/sample/Index.vue"
          ),
        meta: {
          ifHidePadding: true,
          module: INTERVIEW_MODULE.SAMPLE,
        },
      },
      {
        path: "sample/attribute-manage",
        name: "InterviewSampleAtrributeManage",
        component: () =>
          import(
            /* webpackChunkName: 'Interview' */ "@/views/sample/AttributeManage.vue"
          ),
        meta: {
          ifHidePadding: true,
          module: INTERVIEW_MODULE.SAMPLE,
        },
      },
    ],
  },
  {
    path: "/attachment/preview",
    name: "InterviewAttachmentPreview",
    component: () =>
      import(
        /* webpackChunkName: 'Interview' */ "@/views/attachment/components/AttachmentOfficePreviewer.vue"
      ),
    meta: {
      ifHidePadding: true,
      module: INTERVIEW_MODULE.ATTACHMENT,
    },
  },
  // {
  //   path: "/analysis",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'Layout' */ "@/components/layout/AnalysisLayout.vue"
  //     ),
  //   children: [
  //     {
  //       path: "index",
  //       name: "AnalysisIndex",
  //       component: () =>
  //         import(/* webpackChunkName: 'Home' */ "@/views/analysis/Index.vue"),
  //       meta: {
  //         ifHidePadding: true,
  //       },
  //     },
  //   ],
  // },
];

const router = createRouter({
  history: createWebHistory("/"),
  // history: createWebHistory(process.env.BASE_URL),
  routes,
});

//路由守卫
const whiteList = ["/", "/pricing", "/login"];
//全局前置守卫
router.beforeEach(async (to, from, next) => {
  if (to.matched.length === 0) {
    // 如果未匹配到路由

    next("/");
  }
  // 刷新Token
  if (!VueCookies.isKey("tokenWeb") && VueCookies.isKey("tokenWebRefresh")) {
    await httpPostRefreshToken(
      "/oauth/token",
      VueCookies.get("tokenWebRefresh")
    );
  }
  if (checkUserLoginStatus()) {
    await synchronizeUserPermission();

    if (whiteList.indexOf(to.path) == -1 && whiteList.indexOf(to.name) == -1) {
      ws.openSocket("", getWebsocketMessage);
    }
    // 获取用户权限
    if (to.path === "/login") {
      next("/home");
    }
    next();
  } else {
    if (
      whiteList.indexOf(to.path) !== -1 ||
      whiteList.indexOf(to.name) !== -1
    ) {
      next();
    } else {
      // next("/login");
      goLogin();
    }
    ws.closeSocket();
  }
});

export default router;
